import { SiblingCandidates } from './groupSuggestionsBySibling'

export type RowAction = 'accept' | 'review' | 'skip'

export interface RowResolution {
  customer: string[]
  supplier: string[]
}

// Source record ids to forward to the target company, per side.
export interface SiblingDecision {
  forwardCustomer: string[]
  forwardSupplier: string[]
}

export const CONFIDENT_THRESHOLD = 0.9

export const defaultRowAction = (candidates: SiblingCandidates): RowAction => {
  const customer = candidates.customer[0]
  const supplier = candidates.supplier[0]
  if (!customer && !supplier) return 'skip'
  const confident =
    (customer?.confidence ?? 0) >= CONFIDENT_THRESHOLD && (supplier?.confidence ?? 0) >= CONFIDENT_THRESHOLD
  return confident ? 'accept' : 'review'
}

export const buildSiblingDecision = (
  rowAction: RowAction,
  resolution: RowResolution | undefined,
  candidates: SiblingCandidates
): SiblingDecision => {
  const decision: SiblingDecision = { forwardCustomer: [], forwardSupplier: [] }

  if (rowAction === 'accept') {
    // Automatic acceptance stays conservative — only ever the single best match per side.
    // Adding further links for a sibling is a deliberate, reviewed action (see 'review' below).
    if (candidates.customer[0]) decision.forwardCustomer = [candidates.customer[0].sourceId]
    if (candidates.supplier[0]) decision.forwardSupplier = [candidates.supplier[0].sourceId]
  } else if (rowAction === 'review' && resolution) {
    // Keep the user's pick order, drop any id that is no longer an offered candidate.
    decision.forwardCustomer = resolution.customer.filter(id =>
      candidates.customer.some(candidate => candidate.sourceId === id)
    )
    decision.forwardSupplier = resolution.supplier.filter(id =>
      candidates.supplier.some(candidate => candidate.sourceId === id)
    )
  }

  return decision
}
